import { DATE_FORMAT_LONG } from "Common/constants";
import moment from "moment";

export const formatDate = d =>
  d ? moment.parseZone(d).format(DATE_FORMAT_LONG) : null;